import React, { useEffect, useMemo } from 'react';
import { Spin, VirtualTable } from '@fx-ui/fine-design';
import { MessageSettingConfig } from '../../components';
import { MESSAGE_WIDTH } from '../../constants';
import { useMessageConfig } from '../../hooks';
import { MessageConfig, MessageConfigData } from '../../interfaces';
import { platformIntl } from '../../../../constants';
import { getScrollbarSize } from '../../utils';

interface IMessageSettingContent {
    type: string; // 主菜单key
    tableWidth: number;
}

/**
 * 通知管理内容
 *
 * @param props IMessageSettingContent
 * @class
 */
const MessageSettingContent: React.FC<IMessageSettingContent> = (props) => {
    const { type, tableWidth } = props;
    const { messageConfig, fetchMessageConfig } = useMessageConfig();

    useEffect(() => {
        fetchMessageConfig(type);
    }, [type]);

    const messageSettingTableColumns = useMemo(() => {
        // 需要预先在表格右侧留出一个滚动条宽度占位，大概是 12px，防止表格容器一直出现水平滚动条
        const { width: scrollBarWidth } = getScrollbarSize();

        return [
            {
                title: platformIntl.get('msg.type'),
                dataIndex: 'label',
                width: MESSAGE_WIDTH.MESSAGE_TYPE_COL_WIDTH
            },
            {
                title: platformIntl.get('msg.method'),
                dataIndex: 'config',
                width: tableWidth - scrollBarWidth - MESSAGE_WIDTH.MESSAGE_TYPE_COL_WIDTH,
                render: (config: MessageConfigData, row: MessageConfig['notify_config'][0]) => {
                    return (
                        <MessageSettingConfig
                            key={row.key}
                            type={type}
                            subType={row.key}
                            configData={config}
                        />
                    );
                }
            }
        ];
    }, [type, tableWidth]);

    if (!messageConfig) {
        return <Spin />;
    }

    return (
        <div className="fx-message-setting-content">
            <VirtualTable
                className="message-setting-table"
                fixedHeader
                striped={false}
                hasOutBorder={false}
                size="large"
                columns={messageSettingTableColumns}
                dataSource={messageConfig?.notify_config ?? []}
            />
        </div>
    );
};

export default MessageSettingContent;
